import { useQuery } from "@tanstack/react-query";
import ApiRequest from "../ApiRequest";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import { QUERY_KEYS } from "./querykeys";
import { requestURLs } from "@/Environment";
import { ProjectDefaultViewEnumValue } from "@backend/src/schemas/enums";
import { AssignedUsers } from "./useProjectQuery";

export interface ProjectDetailType {
  projectId: string;
  organisationId: string;
  projectName: string;
  projectDescription: string;
  startDate: string;
  estimatedEndDate: string;
  status: string;
  defaultView: keyof typeof ProjectDefaultViewEnumValue;
  timeTrack: string | null;
  budgetTrack: string | null;
  estimatedBudget: string;
  actualCost: string | null;
  overallTrack:string|null;
  progressionPercentage: string | null ;
  createdByUserId: string;
  updatedByUserId: string;
  createdAt: string;
  updatedAt: string;
  tasks: [];
  createdByUser: CreatedByUser;
  projectProgression: string | null;
  assignedUsers:AssignedUsers[];
  actualEndDate:Date |null;
  estimatedDuration?: number;
  actualDuration?: number;
  actualStartDate?:Date|null
  portfolio?: { portfolioId: string } | null;
  program?: { programId: string } | null;
  projectCode?: string;
  isActive?: boolean;
  currency?: string;
}

export interface CreatedByUser {
  firstName: string;
  lastName: string;
  email: string;
  avatarImg: string | null ;
}
type ProjectDetailsApiResponse = ResponseType<ProjectDetailType>;

function useProjectDetail(id: string | undefined, enabled = false) {
  return useQuery<
    AxiosResponseAndError<ProjectDetailsApiResponse>["response"],
    AxiosResponseAndError<ProjectDetailsApiResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.getProjectDetails, id],
    queryFn: async ({ signal }) =>
      await ApiRequest.get(`${requestURLs.project}/${id}`, { signal }),
    enabled: Boolean(enabled && id),
    staleTime: 60 * 1000,
  });
}
export default useProjectDetail;